// src/components/forms/CronogramaForm.jsx
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { toast } from "react-toastify";

import SelectField from "../ui/SelectField";
import InputField from "../ui/InputField";
import SelectSimple from "../ui/SelectSimple";
import TextAreaField from "../ui/TextAreaField";

const TiposMantenimiento = ["Preventivo", "Correctivo", "Calibración"];

const CronogramaForm = ({ mantenimiento = null, onClose, onSave }) => {
  const [form, setForm] = useState({
    equipo: "",
    fechaProgramada: "",
    tipo: "Preventivo",
    estado: "Programado",
    observaciones: "",
    responsable: "",
  });

  const [equipos, setEquipos] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const fetchEquipos = useCallback(async () => {
    const res = await axios.get(`${API}/equipos`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setEquipos(res.data);
  }, [API, token]);

  const fetchPersonas = useCallback(async () => {
    const res = await axios.get(`${API}/users/resp`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setPersonas(res.data);
  }, [API, token]);

  useEffect(() => {
    fetchEquipos();
    fetchPersonas();
  }, [fetchEquipos, fetchPersonas]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await onSave({ ...form, responsable: form.responsable || null });
      toast.success("Servicio programado correctamente");
    } catch (err) {
      toast.error("Error al guardar el servicio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl w-full max-w-2xl">
        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <SelectField
                label="Equipo *"
                name="equipo"
                value={form.equipo}
                onChange={handleChange}
                options={equipos}
                displayFn={(eq) =>
                  `[${eq.serial}] ${eq.marca?.name} ${eq.modelo?.name}`
                }
              />

              <InputField
                label="Fecha programada *"
                type="datetime-local"
                name="fechaProgramada"
                value={form.fechaProgramada}
                onChange={handleChange}
              />

              <SelectSimple
                label="Tipo de mantenimiento *"
                name="tipo"
                value={form.tipo}
                onChange={handleChange}
                options={TiposMantenimiento}
              />

              <SelectField
                label="Responsable"
                name="responsable"
                value={form.responsable}
                onChange={handleChange}
                options={personas}
                displayFn={(p) => `${p.name} (${p.email})`}
              />

              <TextAreaField
                label="Observaciones"
                name="observaciones"
                value={form.observaciones}
                onChange={handleChange}
              />

              <div className="flex justify-end gap-2 pt-4">
                <Button type="button" onClick={onClose} variant="destructive">
                  Cancelar
                </Button>
                <Button type="submit" disabled={loading}>
                  {loading ? "Guardando..." : "Guardar"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CronogramaForm;
